import type { ITrial } from '../interfaces/ITrial';
import { ApiClientService } from './ApiClientService';

const getTrialUrl = (path = '') => `${ApiClientService.getApiBaseUrl()}/trials${path}`;

export const getTrial = async (): Promise<ITrial | null> => {
  return ApiClientService.getJson<ITrial>(getTrialUrl());
};

export const setTrialNotificationSeen = async () => {
  return ApiClientService.putJson<string>(getTrialUrl('/initialNotification'), {});
};

export const setTrialNotified5DaysSeen = async () => {
  return ApiClientService.putJson<string>(getTrialUrl('/notified5Days'), {});
};

export const setTrialEndedSeen = async () => {
  return ApiClientService.putJson<string>(getTrialUrl('/trialEnded'), {});
};
